import {BannerCfgJs} from 'OK/banners/bannerNew/config/BannerCfgJs';
import {createLog} from 'OK/banners/bannerNew/utils/BannerCommon';
import {RequestJs} from 'OK/banners/bannerNew/BannerModelJs';
import type { TBaseParams, IBannerTransportJs } from "OK/banners/bannerNew/transport/IBannerTransportJs";
import {BannerTransportJs, ReqId} from "OK/banners/bannerNew/transport/BannerTransportJs";
import * as logger from 'OK/logger';
import {BannerDataIframe} from "OK/banners/bannerNew/data/BannerDataIframe";
import {BannerPlaceListenersProxyJs} from "OK/banners/bannerNew/BannerPlaceListenersProxyJs";

const log = createLog('AdfBannerTransportJs');

let runnings: Record<string, number> = {};
let requestIdToRunningId: Record<string, string> = {}
let lastRequestId = 1;
let lastRunningId = 0
let respNum = 0;

const CLICK_TIMEOUT = 100;

const bannerPlaceListenersProxy = BannerPlaceListenersProxyJs.getInstance();

let instance: AdfBannerTransportJs | null = null;

export class AdfBannerTransportJs implements IBannerTransportJs {

    constructor() {
    }

    sendRequest(slot: number, params: object, request: RequestJs) {
        if (!BannerCfgJs.getMultiLoad()?.adqEnabled) {
            return;
        }
        const requestId = buildRequestId();
        const requestHolder = RequestHolderJs.create(requestId, slot, request, params);
        this.execute(request.container, requestHolder);
    }

    private execute(container: HTMLElement, requestHolder: RequestHolderJs) {
        const slot = requestHolder.slot;
        const requestId = requestHolder.requestId;
        /*
         * Логируем вызов РБ
         * param1 — текущая страница
         * param2 — номер слота
         */
        const modelId = (OK.getCurrentDesktopModelId && OK.getCurrentDesktopModelId()) || 'nogwt';
        logger.success('ad', modelId, 'js_adf.' + slot);

        const baseUrl = BannerCfgJs.getMultiLoad()?.adfTransportUrl;

        const url = `${baseUrl}${slot}?_SITEID=163&${BannerTransportJs.encodeParams(requestHolder.params)}`;
        this.appendIframe(container, url, requestHolder);
    }

    appendIframe(container: HTMLElement, requestUrl: string, requestHolder: RequestHolderJs) {
        const runningId = (lastRunningId++) + '';
        requestIdToRunningId[requestHolder.requestId] = runningId;
        const iframe = document.createElement("iframe");
        iframe.src = requestUrl + '&nn=' + respNum;
        iframe.width = '240';
        iframe.height = '400';
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('hspace', '0');
        iframe.setAttribute('marginwidth', '0');
        iframe.setAttribute('marginheight', '0');
        iframe.setAttribute('scrolling', 'no');
        iframe.id = buildWrapperId(runningId);
        container.appendChild(iframe);
        runnings[runningId] = Date.now();

        const callbacksEnabled = BannerCfgJs.getInstance().callbacksEnabled;
        if (callbacksEnabled) {
            log('iframe tag appended, request: ' + requestHolder.getReqId());
            try {
                bannerPlaceListenersProxy.onRequest(requestHolder.getReqId());
            } catch (ex) {
                logger.errorEx(ex as Error, 'AdfBannerTransport', 'iframe_on_request');
            }
        }

        const listener = new IframeOnLoadEventListener(iframe, requestHolder, callbacksEnabled);
        iframe.addEventListener('load', listener);
    }

    sendClick(clickUrl: string, params: TBaseParams) {
        setTimeout(() => {
            const img = new Image();
            img.src = `${clickUrl}?${BannerTransportJs.encodeParams(params)}`;
        }, CLICK_TIMEOUT);
    }

    static getInstance() {
        if (instance === null) {
            instance = new AdfBannerTransportJs();
        }
        return instance;
    }
}

class IframeOnLoadEventListener {
    iframe: HTMLIFrameElement;
    requestHolder: RequestHolderJs;
    callback: CallbackJs;
    callbacksEnabled: boolean;

    constructor(iframe: HTMLIFrameElement, requestHolder: RequestHolderJs, callbacksEnabled: boolean) {
        this.iframe = iframe;
        this.requestHolder = requestHolder;
        this.callback = new CallbackJs(requestHolder);
        this.callbacksEnabled = callbacksEnabled;
    }

    handleEvent(e: Event) {
        const reqId = this.requestHolder.getReqId();
        log('iframe on \'' + e.type + '\' event handling, request: ' + reqId);
        try {
            if (this.callbacksEnabled) {
                bannerPlaceListenersProxy.onLoadSuccess(reqId);
            }

            this.callback.handleResponse(this.iframe);

            if (this.callbacksEnabled) {
                bannerPlaceListenersProxy.onAdsSuccess(reqId);
            }
        } catch (ex) {
            if (this.callbacksEnabled) {
                bannerPlaceListenersProxy.onScriptError(reqId);
            }
            logger.errorEx(ex as Error, 'AdfBannerTransport', 'iframe_on_load');
        }
        try {
            const id = this.requestHolder.requestId;
            const runningId = requestIdToRunningId[id];
            delete requestIdToRunningId[id];
            if (runningId) {
                cleanupRunning(runningId);
            }
        } catch (ex) {
            logger.errorEx(ex as Error, 'AdfBannerTransport', 'cleanup');
        } finally {
            this.iframe.removeEventListener('load', this);
        }
    }
}

function buildWrapperId(runningId: string): string {
    return 'adf_blwrapper_' + runningId;
}

function buildRequestId(): string {
    return 'nbnr' + (lastRequestId++);
}

function cleanupRunning(runningId: string) {
    try {
        delete runnings[runningId];

        const elementId = buildWrapperId(runningId);
        const wrapper = document.getElementById(elementId);

        if (wrapper !== null) {
            respNum++;
        }
    } catch (e) {
        logger.errorEx(e as Error, 'AdfBannerTransport', 'cleanup_running');
        throw e;
    }
}

class CallbackJs {
    request: RequestJs;

    constructor(requestHolder: RequestHolderJs) {
        this.request = requestHolder.request;
        this.request.setCancellationListener(this);
    }

    handleResponse(iframe: HTMLElement) {
        const bannerData = new BannerDataIframe(iframe.id);
        this.request.handleBannerDataResponse(bannerData);
    }

    onCancel() {
    }
}

class RequestHolderJs {
    slot!: number;
    requestId!: string;
    request!: RequestJs;
    params: Record<string, any>;

    constructor() {
        this.params = {};
    }

    static create(requestId: string, slot: number, request: RequestJs, params: Record<string, any>) {
        const holder = new RequestHolderJs();
        holder.slot = slot;
        holder.requestId = requestId;
        holder.request = request;
        const keys = Object.getOwnPropertyNames(params);
        if (keys.length) {
            keys.forEach(key => {
                holder.params[key] = params[key];
            });
        }
        BannerTransportJs.appendCookielessUserSyncParameters(holder.params);
        return holder;
    }

    getReqId() {
        return new ReqId(this.requestId, this.request.bannerPlace!, this.slot)
            .setTransport('js_adf');
    }
}
